import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import StatCard from "./ui/StatCard";
import DataCard from "./ui/DataCard";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const Reports = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getReports().then(setData).catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading reports..." />;
  if (error) return <AlertBanner type="danger" message={error} />;

  return (
    <div>
      <PageHeader title="Reports" subtitle="Bill payment analytics and support metrics" />

      <Row className="g-3 mb-4">
        <Col md={4}>
          <StatCard label="Open Tickets" value={data.supportStats.open_tickets} accent="#6366f1" iconBg="#eef2ff" />
        </Col>
        <Col md={4}>
          <StatCard label="Pending Calls" value={data.supportStats.pending_calls} accent="#f59e0b" iconBg="#fef3c7" />
        </Col>
        <Col md={4}>
          <StatCard label="Calls Today" value={data.supportStats.calls_today} accent="#10b981" iconBg="#d1fae5" />
        </Col>
      </Row>

      <DataCard title="Revenue by Bill Type">
        <Table responsive className="billr-table mb-0">
          <thead><tr><th>Bill Type</th><th>Transactions</th><th>Revenue (INR)</th></tr></thead>
          <tbody>
            {data.byCategory.map((row, i) => (
              <tr key={i}>
                <td><strong>{row.bill_type}</strong></td>
                <td>{row.txn_count}</td>
                <td>₹{parseFloat(row.revenue || 0).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataCard>

      <Row className="g-3 mt-1">
        <Col md={6}>
          <DataCard title="Monthly Trend">
            <Table responsive className="billr-table mb-0">
              <thead><tr><th>Month</th><th>Txns</th><th>Revenue</th></tr></thead>
              <tbody>
                {data.monthly.map((m) => (
                  <tr key={m.month}><td>{m.month}</td><td>{m.txn_count}</td><td>₹{parseFloat(m.revenue || 0).toLocaleString("en-IN")}</td></tr>
                ))}
              </tbody>
            </Table>
          </DataCard>
        </Col>
        <Col md={6}>
          <DataCard title="Invoice Summary">
            <Table responsive className="billr-table mb-0">
              <thead><tr><th>Status</th><th>Count</th><th>Total</th></tr></thead>
              <tbody>
                {data.invoiceStats.map((inv) => (
                  <tr key={inv.status}><td>{inv.status}</td><td>{inv.count}</td><td>₹{parseFloat(inv.total || 0).toLocaleString("en-IN")}</td></tr>
                ))}
              </tbody>
            </Table>
          </DataCard>
        </Col>
      </Row>
    </div>
  );
};

export default Reports;
